export default async (method) =>
{
  const url = '/Sys/Admin/twofactorauth/sendcode';
  const response = await fetch(
    url,
    {
      method: 'POST',
      body: JSON.stringify({ method }),
      headers: { 'Content-Type': 'application/json' }
    });

  return response.json();
};